export default __webpack_public_path__ + "static/media/Pilgrim's Robes of the Eldritch.150a6fe1.jpg";